
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const usePersonalPlanDetector = (routineId: string) => {
  const query = useQuery({
    queryKey: ["personal-plan-detector", routineId],
    queryFn: async () => {
      console.log(`🔍 Detecting if routine ${routineId} is in personal plan`);
      
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      // Optimized query - only check if routine is linked to user's personal plan
      const { data, error } = await supabase
        .from("workout_plan_routines")
        .select(`
          workout_plan_id,
          workout_plans!inner(is_personal, created_by)
        `)
        .eq("routine_id", routineId)
        .eq("workout_plans.created_by", user.id)
        .eq("workout_plans.is_personal", true)
        .limit(1);

      if (error) {
        console.error("Error detecting personal plan:", error);
        return false;
      }

      const isPersonal = data && data.length > 0;
      console.log(`✅ Routine ${routineId} personal plan status:`, isPersonal);
      return isPersonal;
    },
    enabled: !!routineId,
    staleTime: 300000, // 5 minutes - personal plan status doesn't change often
    gcTime: 600000, // 10 minutes
  });

  return {
    isPersonalPlan: query.data ?? false,
    isLoading: query.isLoading,
    error: query.error
  };
};
